import React from 'react';
import { Modal, Button } from 'react-bootstrap';

type Props = {
  show: boolean;
  itemLabel?: string;
  confirming?: boolean;
  onHide: () => void;
  /** 尚未提交申请时走去采购 */
  onGoPurchase: () => void;
  /** 确认已提交申请，清除提醒 */
  onConfirmCleared: () => void;
};

/**
 * 低库存提醒：手动标记已处理（确认后立即清除提醒）
 */
export const ManualClearRestockModal: React.FC<Props> = ({
  show,
  itemLabel,
  confirming = false,
  onHide,
  onGoPurchase,
  onConfirmCleared
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>手动标记已处理</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          手动标注后，该低库存提醒将被清除
          {itemLabel ? `（${itemLabel}）` : ''}
          。
        </p>
        <p className="mb-0 text-muted">
          请确认该低库存已提交正式采购申请。若尚未提交，请先点击「去采购」。
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex flex-wrap gap-2 justify-content-between">
        <Button variant="outline-secondary" onClick={onHide} disabled={confirming}>
          取消
        </Button>
        <div className="d-flex flex-wrap gap-2">
          <Button variant="outline-primary" onClick={onGoPurchase} disabled={confirming}>
            去采购
          </Button>
          <Button variant="primary" onClick={onConfirmCleared} disabled={confirming}>
            {confirming ? '处理中…' : '确认已处理'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
